import styled from "styled-components";

export const Wrapper = styled.section`
  background-color: #f4f8fb;
  min-height: 100vh;
  padding: 4rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  background: white;
  padding: 3rem 2rem;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

export const Title = styled.h1`
  font-size: 1.8rem;
  color: #0077cc;
  margin-bottom: 1rem;
  text-align: center;
`;

export const Paragraph = styled.p`
  font-size: 1rem;
  color: #444;
  margin-bottom: 2rem;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const Input = styled.input`
  padding: 0.9rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
`;

export const Button = styled.button`
  background-color: #0077cc;
  color: white;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #005fa3;
  }
`;

export const SuccessMessage = styled.p`
  font-size: 1.1rem;
  color: green;
  text-align: center;
  margin-top: 2rem;
`;
